module.exports = __webpack_public_path__ + "img/product-shot_01.d4d084fc.jpg";